<template>
<div>
  <div class="display-option-container">
    <div class="display-options btn-group">
      <button v-on:click.stop.prevent="setDisplayMode('grid')" class="btn btn-dark"><svg class="icon icon-grid-three-up"><use xlink:href="#icon-grid-three-up"></use></svg></button>
      <button v-on:click.stop.prevent="setDisplayMode('list')" class="btn btn-dark"><svg class="icon icon-list"><use xlink:href="#icon-list"></use></svg></button>
    </div>
  </div>
  <div class="container" id="main">
    <form>
      <div class="form-row">
        <div class="col-8">
          <div class="form-group">
            <input type="search" v-model="search" placeholder="Search" class="form-control" @input="updateResults" />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <v-select v-model="property" placeholder="Source" :options="sources" @input="onSourceChange"></v-select>
          </div>
        </div>
      </div>
    </form>
    <div v-if="displayMode == 'grid'" class="row">
      <div class="col-4 card-container" v-for="row in rows" :key="row._id">
        <div class="card">
          <img class="card-img-top" v-bind:src="row.image" />
          <div class="card-body">
            <h6 class="badge text-white" v-bind:style="'background-color:' + row.property.color">{{row.property.title}}</h6>
            <h5 class="card-title">{{row.title}}</h5>
            <div>
              <small v-if="isPublished(row.published)" class="text-success">Published: {{toLocaleString(row.published)}}</small>
              <small v-else class="text-danger">Scheduled: {{toLocaleString(row.published)}}</small>
            </div>
            <div>
              <small class="text-muted">Updated: {{toLocaleString(row.updatedAt)}}</small>
            </div>
            <div class="story-links">
              <span v-for="link in row.linked" :key="link._id" class="badge text-white" v-bind:style="'background-color:' + link.color">{{link.title}}</span>
            </div>
          </div>
          <div class="btn-group story-actions-grid">
            <a target="_blank" rel="noreferrer noopener" v-bind:class="isPublished(row.published)? 'btn btn-sm btn-outline-secondary col':'btn btn-sm btn-outline-secondary col disabled'" v-bind:href="row.url"><svg class="icon icon-eye"><use xlink:href="#icon-eye"></use></svg><span>View</span></a>
            <a target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-secondary col" v-bind:href="row.property.endpoint + '/administrator/index.php?option=com_news&view=story&task=story.edit&id=' + row.id"><svg class="icon icon-pencil"><use xlink:href="#icon-pencil"></use></svg><span>Edit</span></a>
          </div>
          <div class="card-footer">
            <router-link class="btn btn-primary btn-block btn-sm" :to="'/story/' + row._id"><svg class="icon icon-signpost"><use xlink:href="#icon-signpost"></use></svg><span>Send</span></router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-else>
      <table class="table table-light">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Image</th>
            <th scope="col">Title</th>
            <th scope="col">Published</th>
            <th scope="col">Updated</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row._id">
            <td><img style="max-width: 100px;" v-bind:src="row.image" /></td>
            <td>
              <h5 class="badge text-white" v-bind:style="'background-color:' + row.property.color">{{row.property.title}}</h5>
              <div>{{row.title}}</div>
              <div class="story-links">
                <span v-for="link in row.linked" :key="link._id" class="badge text-white" v-bind:style="'background-color:' + link.color">{{link.title}}</span>
              </div>
            </td>
            <td nowrap>
              <small v-if="isPublished(row.published)" class="text-success">{{toLocaleString(row.published)}}</small>
              <small v-else class="text-danger">{{toLocaleString(row.published)}}</small>
            </td>
            <td nowrap><small>{{toLocaleString(row.updatedAt)}}</small></td>
            <td>
              <div class="btn-group">
                <a target="_blank" rel="noreferrer noopener" v-bind:class="isPublished(row.published)? 'btn btn-sm btn-outline-secondary':'btn btn-sm btn-outline-secondary disabled'" v-bind:href="row.url"><svg class="icon icon-eye"><use xlink:href="#icon-eye"></use></svg><span>View</span></a>
                <a target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-secondary" v-bind:href="row.property.endpoint + '/administrator/index.php?option=com_news&view=story&task=story.edit&id=' + row.id"><svg class="icon icon-pencil"><use xlink:href="#icon-pencil"></use></svg><span>Edit</span></a>
                <router-link class="btn btn-sm btn-outline-secondary" :to="'/story/' + row._id"><svg class="icon icon-signpost"><use xlink:href="#icon-signpost"></use></svg><span>Send</span></router-link>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="progress" style="margin: 20px 0;" v-show="pagination">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
    </div>
  </div>
</div>
</template>
<script>
import {
  api
} from '../api.js';
import ui from '../ui.js';
import {
  DateTime
} from 'luxon';
import debounce from 'debounce';
import vSelect from 'vue-select';
export default {
  name: 'Stories',
  components: {
    vSelect
  },
  data: function() {
    return {
      displayMode: window.localStorage.getItem('display') || 'grid',
      rows: [],
      pagination: false,
      fetching: false,
      page: 1,
      total: 0,
      properties: [],
      sources: [],
      property: window.localStorage.getItem('source') ? JSON.parse(window.localStorage.getItem('source')) : null,
      search: ''
    }
  },
  mounted: function() {
    window.addEventListener('scroll', this.onScroll);
    this.fetching = true;
    this.fetch();
    api.get('/properties', {
      params: {
        limit: 20
      }
    }).then((response) => {
      this.properties = response.data.docs;
      this.properties.forEach((property) => {
        this.sources.push({
          label: property.title,
          value: property._id
        });
      });
    }).catch((error) => {
      ui.alert(error.response.data);
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: function() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        if (this.pagination && !this.fetching) {
          this.fetching = true;
          this.paginate();
        }
      }
    },
    paginate: function() {
      this.page++;
      this.fetch();
    },
    fetch: function() {
      let params = {
        limit: 12,
        page: this.page,
        search: this.search,
        status: 'published'
      };
      if (this.property) {
        params.properties = [this.property.value];
      }
      api.get('/stories', {
        params: params
      }).then((response) => {
        response.data.docs.forEach((doc) => {
          this.rows.push(doc);
        });
        this.total = response.data.total;
        this.pagination = response.data.page < response.data.pages;
        this.fetching = false;
      }).catch((error) => {
        this.fetching = false;
        ui.alert(error.response.data);
      });
    },
    onSourceChange: function() {
      window.localStorage.setItem('source', JSON.stringify(this.property));
      this.updateResults();
    },
    updateResults: debounce(function() {
      this.rows = [];
      this.page = 1;
      this.fetch();
    }, 200),
    toLocaleString: function(value) {
      var updated = DateTime.fromISO(value, {
        zone: 'UTC'
      });
      var local = updated.setZone('Europe/Athens');
      return local.toLocaleString(DateTime.DATETIME_SHORT);
    },
    isPublished: function(value) {
      let publishTime = DateTime.fromISO(value);
      let now = DateTime.local();
      return publishTime < now;
    },
    setDisplayMode: function(value) {
      this.displayMode = value;
      window.localStorage.setItem('display', value);
    }
  }
}
</script>
